import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
       
    }

    .radio-group {
        border: none;
        margin: 0 0 var(--sbkCoreSpacingMd) 0;
        padding: 0;

        .label__wrapper + sbk-annotation {
            margin-top: calc(var(--sbkInput3xs) * -1);
            margin-bottom: var(--sbkInput3xs);
        }
    }

    .radio-slot {
        display: flex;
        flex-direction: column;
        gap: var(--sbkCoreSpacing3xs);
    }

    @media all and (min-width: ${breakpointLg}) {
        .radio-group--horizontal .radio-slot {
            flex-direction: row;
            gap: var(--sbkCoreSpacingXsBase);
        }
    }
`;
